import * as React from "react";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

export default function HubHeaderMenu({onBuildHistoryClick, onExportIndicatorsClick, onHubConfigurationClick}) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleBuildHistoryClick = () => {
        if (onBuildHistoryClick) onBuildHistoryClick();
        handleClose();
    };

    const handleExportIndicatorsClick = () => {
        if (onExportIndicatorsClick) onExportIndicatorsClick();
        handleClose();
    };

    const handleHubConfigurationClick = () => {
        if (onHubConfigurationClick) onHubConfigurationClick();
        handleClose();
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon/>
            </IconButton>
            <Menu
                id="hub-header-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem disabled onClick={handleBuildHistoryClick}>BUILD HISTORY</MenuItem>
                <MenuItem disabled onClick={handleExportIndicatorsClick}>EXPORT INDICATORS</MenuItem>
                <MenuItem onClick={handleHubConfigurationClick}>HUB CONFIGURATION</MenuItem>
            </Menu>
        </div>
    );
}